export const styleConfig = {
    ipadPro: {
        contributionsTab: {
            defaultWidth: 70,
            customStyles: [
                {
                    column: 4,
                    textAlign: 'right',
                    sorterPos: 67,
                    width: 130
                },
                {
                    column: 5,
                    textAlign: 'right',
                    sorterPos: 61,
                    width: 130
                }
            ]
        },
        transGrantsTab: {
            defaultWidth: 65,
            customStyles: [
                {
                    column: 1,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 70
                },      
                {
                    column: 5,
                    textAlign: 'right',
                    sorterPos: 51,
                    width: 120
                },
                {
                    column: 6,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 80
                },
                {
                    column: 8,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 30
                }
            ]
        },
        exchangeTab: {
            defaultWidth: 97,
            customStyles: [
                {
                    column: 3,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 132
                },
                {
                    column: 4,
                    textAlign: 'right',
                    sorterPos: 62,
                    width: 130
                },
                {
                    column: 6,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 40
                }
            ]
        },
        otherTransactionTab: {
            defaultWidth: 97,
            customStyles: [
                {
                    column: 5,
                    textAlign: 'right',
                    sorterPos: 15,
                    width: 130
                }
            ]
        },
        allTransactionTab: {
            defaultWidth: 97,
            customStyles: [
                {
                    column: 4,
                    textAlign: 'right',
                    sorterPos: 15,
                    width: 130
                },
                {
                    column: 6,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 40
                }
            ]
        }
    },
    desktop: {
        contributionsTab: {
            defaultWidth: 90,
            customStyles: [
                {
                    column: 4,
                    textAlign: 'right',
                    sorterPos: 67,
                    width: 130
                },
                {
                    column: 5,
                    textAlign: 'right',
                    sorterPos: 61,
                    width: 130
                }
            ]
        },
        transGrantsTab: {
            defaultWidth: 90,
            customStyles: [
                {
                    column: 3,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 98
                },
                {
                    column: 4,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 93
                },                   
                {
                    column: 5,
                    textAlign: 'right',
                    sorterPos: 51,
                    width: 120
                },                
                {
                    column: 8,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 30
                }
            ]
        },
        exchangeTab: {
            defaultWidth: 110,
            customStyles: [
                {
                    column: 3,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 132
                },
                {
                    column: 4,
                    textAlign: 'right',
                    sorterPos: 62,
                    width: 130
                },
                {
                    column: 6,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 60
                }
            ]
        },
        otherTransactionTab: {
            defaultWidth: 110,
            customStyles: [
                {
                    column: 5,
                    textAlign: 'right',
                    sorterPos: 15,
                    width: 130
                }
            ]
        },
        allTransactionTab: {
            defaultWidth: 110,
            customStyles: [
                {
                    column: 4,
                    textAlign: 'right',
                    sorterPos: 15,
                    width: 130
                },
                {
                    column: 6,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 60
                }
            ]
        }
    }
  }